import { render, staticRenderFns } from "./SenaSendNotification.vue?vue&type=template&id=48266488&"
import script from "./SenaSendNotification.vue?vue&type=script&lang=js&"
export * from "./SenaSendNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports